import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { VscSignOut } from "react-icons/vsc";
import { logout } from "../../../services/operations/authAPI.service";
import SidebarLink from "./SidebarLink";
import { sidebarLinks } from "../../../data/dashboard-links";
import ConfirmationModal from "../../common/ConfirmationModal";
import { VscSettingsGear } from "react-icons/vsc";
import { ACCOUNT_TYPE } from "../../../utils/constants";

const Sidebar = () => {
  const { loading: authLoading } = useSelector((state) => state.auth);
  const { user, loading: profileLoading } = useSelector(
    (state) => state.profile
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(null);

  if (profileLoading || authLoading) {
    return <div className="mt-10 spinner"></div>;
  }

  return (
    <div className="flex h-[calc(100vh-3.5rem)] md:min-w-[220px] flex-col border-r-[1px] border-r-richblack-700 bg-richblack-900 py-10">
      <div className="flex flex-col">
        {sidebarLinks.map((link) => {
          if (link.type && user?.accountType !== link.type) return null;
          return <SidebarLink key={link.id} link={link} iconName={link.icon} />;
        })}
      </div>

      <div className="mx-auto mt-6 mb-6 h-[1px] w-10/12 bg-richblack-700"></div>

      <div className="flex flex-col">
        {user?.accountType !== ACCOUNT_TYPE.ADMIN && (
          <SidebarLink
            link={{ name: "Settings", path: "settings" }}
            iconName={VscSettingsGear}
          />
        )}

        <button
          onClick={() =>
            setConfirmationModal({
              text1: "Are You Sure ?",
              text2: "You will be logged out of your account",
              btn1Text: "Logout",
              btn2Text: "Cancel",
              btn1Handler: () => dispatch(logout(navigate)),
              btn2Handler: () => setConfirmationModal(null),
            })
          }
          className="px-2 md:px-8 py-2 text-sm font-medium text-richblack-300"
        >
          <div className="flex items-center gap-x-2 transition-all duration-200 hover:text-pink-500">
            <VscSignOut className="text-xl" />
            <span className="hidden md:block">Logout</span>
          </div>
        </button>
      </div>

      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </div>
  );
};

export default Sidebar;
